import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { map, of } from 'rxjs';

import { BulkUploadTcsComponent } from '../../pages/tax-certification/tax-certification-submissions/bulk-upload-tcs/bulk-upload-tcs.component';
import { ModalDialogService } from '../../services/modalDialog/modal-dialog.service';
import { AddTaxCertificationService } from '../../services/tax-certification/add-tax-certification/add-tax-certification.service';

export const bulkTcsDeactivateGuard: CanDeactivateFn<BulkUploadTcsComponent> = (
  component: BulkUploadTcsComponent, 
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot, 
  nextState?: RouterStateSnapshot
) => {
  const addTcs = inject(AddTaxCertificationService);
  const modalService = inject(ModalDialogService);

  if (nextState?.url.includes('/add-tcs/success')) 
    return true;

  if (addTcs.processStage === 'bulkUpload' || addTcs.processStage === 'addTcsComplete') {
    addTcs.resetNewTcsProcessState();
    return true;
  }

  const confirm$ = modalService.showConfirmModal({
    title: 'CANCEL PROCESS',
    message: 'Confirm that you want to cancel this process - progress made will be lost.',
    confirmBtnLabel: 'Cancel process',
    confirmBtnCssClass: 'btn btn-danger px-sm-4',
    cancelBtnLabel: 'Go back',
  });

  return (confirm$ ?? of(false)).pipe(
    map(confirm => {
      if (confirm) {
        addTcs.resetNewTcsProcessState();
        return true;
      }
      return false;
    }),
  );
};
